import { render, staticRenderFns } from "./abouts.vue?vue&type=template&id=45badf3a&scoped=true&"
import script from "./abouts.vue?vue&type=script&lang=js&"
export * from "./abouts.vue?vue&type=script&lang=js&"
import style0 from "./abouts.vue?vue&type=style&index=0&id=45badf3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45badf3a",
  null
  
)

export default component.exports